<template>
  <div class="h-100" style="overflow-y: scroll">
    <template v-if="isRevamp">
      <template v-if="grp_id === statement">
        <CommonStatementDocumentRevamp :grpId="grp_id" />
      </template>
      <template v-if="grp_id === 'deviate'">
        <CommonPreUploadRevamp :lstDocumentDeviate="docList" />
      </template>
    </template>
    <template v-else>
      <template v-if="grp_id === statement">
        <CommonStatementDocument :grpId="grp_id" />
      </template>
      <template v-else>
        <CommonPreUpload :grpId="grp_id" />
      </template>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    CommonStatementDocument: () =>
      import("@/components/TemplateNewScreen/CommonStatementDocument.vue"),
    CommonStatementDocumentRevamp: () =>
      import(
        "@/components/TemplateNewScreen/revamp/CommonStatementDocument.vue"
      ),
    CommonPreUpload: () =>
      import("@/components/TemplateNewScreen/CommonPreUpload.vue"),
    CommonPreUploadRevamp: () =>
      import("@/components/TemplateNewScreen/revamp/CommonPreUpload.vue"),
  },
  data() {
    return {
      userData: {},
      grp_id: null,
      statement: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT,
      productRevamp: process.env.VUE_APP_PRODUCT_REVAMP,
      docList: [],
    };
  },
  computed: {
    isRevamp() {
      const pr = this.productRevamp.split(",");
      return pr.includes(this.userData.marketCode);
    },
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    this.userData = this.$store.getters.getUserData;
    this.grp_id = this.$route.params.grpId;
    this.docList = this.$route.params.docList;
  },
};
</script>
